
import CompareProductsComp from 'applications/desktop/package-compare-app/components/compare-products/compare-products'
export default class CompareProducts extends CompareProductsComp {}
